import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CockpitProcess, LegalEntity } from '@apps/file-process/file-process.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-display-legal-entities-without-processes',
  templateUrl: './display-legal-entities-without-processes.component.html',
  styleUrls: ['./display-legal-entities-without-processes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DisplayLegalEntitiesWithoutProcessesComponent {
  @Input() cockpitProcess$: Observable<CockpitProcess[]>;
  @Input() legalEntities: LegalEntity[];
  @Input() customerSpaceId!: string;
  @Input() processType!: string;

  get createEntityLink() {
    if (this.legalEntities.length === 0) {
      return ['/customer-spaces', this.customerSpaceId, 'file-process', this.processType, 'legal-entities', 'create'];
    } else {
      return ['/customer-spaces', this.customerSpaceId, 'file-process', this.processType, 'legal-entities'];
    }
  }
}
